import loadable from '@loadable/component';
import * as React from 'react';

import { IFavoritesProps } from '../../components/Favorites';
import { LoadableErrorBoundary } from '../../components/LoadableErrorBoundary';
import { useApplicationContext } from '../../utils/applicationContext';

type TFavoritesContainerProps = Pick<IFavoritesProps, 'onClose'>;

const FavoritesLoadable = loadable(() => import(/* webpackChunkName: "Favorites" */ './loadable'), {
  ssr: false,
});

export const FavoritesContainer: React.FC<TFavoritesContainerProps> = ({ onClose }) => {
  const { logger } = useApplicationContext();

  const handleRetry = React.useCallback(() => {
    FavoritesLoadable.load();
  }, []);

  return (
    <LoadableErrorBoundary logger={logger} onRetry={handleRetry}>
      <FavoritesLoadable onClose={onClose} />
    </LoadableErrorBoundary>
  );
};
